import { useOnboarding } from '../contexts/OnboardingContext';
import type { OnboardingProgress } from '../types/onboarding';

type UseOnboardingProgressResult = {
  progress: OnboardingProgress | null;
  loading: boolean;
  celebrationKey: number;
  refresh: () => Promise<void>;
};

export function useOnboardingProgress(): UseOnboardingProgressResult {
  const { progress, loading, celebrationKey, refresh } = useOnboarding();
  return { progress, loading, celebrationKey, refresh };
}
